import CreateAgentFormWrapper from '../components/CreateAgentFormWrapper';
import { Button, Flex, Stack, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { PATHS } from 'router/routes';
import ZaraButton from 'components/custom-components/buttons/Button';
import { useError } from 'error-provider/ErrorProvider';
import { useGetCurrentSubscriptionInfoQuery } from 'graphql/generated';

const TrialConfirmation = () => {
    const router = useNavigate();
    const { showError } = useError();

    const { data, loading } = useGetCurrentSubscriptionInfoQuery({
        fetchPolicy: 'network-only',
        onError(error) {
            showError(undefined, error);
        },
    });

    return (
        <CreateAgentFormWrapper title='Trial Confirmation' description='Your trial has been successfully started!'>
            <Stack spacing='5'>
                <Text fontWeight='bold'>Congratulations!</Text>
                <Text>You've subscribed to the {data?.getCurrentSubscriptionInfo.subscription?.planName} plan.</Text>
                {(data || !loading) && (
                    <>
                        <Text>
                            Your 7-day free trial begins today. After the trial period, your card will be billed 
                            ${`${data?.getCurrentSubscriptionInfo.subscription?.priceAmount}`}/month unless cancelled.
                        </Text>
                        <Text>You can manage your subscription anytime from your account dashboard.</Text>
                        <Flex justifyContent='space-between'>
                            <Button onClick={() => router(PATHS.SUBSCRIPTION_PLAN)} variant='outline' fontSize='sm'>
                                Back
                            </Button>
                            <ZaraButton variant='blackAlpha' onClick={() => router(PATHS.PHONE_PICK)}>
                                Next
                            </ZaraButton>
                        </Flex>
                    </>
                )}
            </Stack>
        </CreateAgentFormWrapper>
    );
};

export default TrialConfirmation;
